import React from "react";
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import BlockIcon from '@material-ui/icons/Block';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import AdjustOutlinedIcon from '@material-ui/icons/AdjustOutlined';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';

//-1 Отклонена
//0 Новая
//1 В работе
//2 Подтверждена
//3 архив

export const StateName = (stateid) => {
  switch(stateid) {
    case 0:
      return "НОВАЯ";
    case 1:
      return "В РАБОТЕ";
    case 2:
      return "ПОДТВЕРЖДЕНА";
    case 3:
      return "АРХИВ";
    case -1:
      return "ОТКЛОНЕНА";
    default:
      return "БЕЗ СТАТУСА";
  }
};

export const SmallStateIcon = (stateid) => {
  switch(stateid) {
    case 0:
      return <AdjustOutlinedIcon/>;
    case 1:
      return <AccessTimeIcon/>;
    case 2:
      return <CheckCircleOutlineIcon/>;
    case 3:
      return <CheckBoxOutlineBlankIcon/>;
    case -1:
      return <BlockIcon/>;
    default:
      return <HelpOutlineIcon/>;
  }
};

export const StateTextColor = (stateid) => {
  switch(stateid) {
    case 0:
      return "#304967";
    case 1:
      return "#007FBD";
    case 2:
      return "#85C446";
    case 3:
      return "#CACCD1";
    case -1:
      return "#F15454";
    default:
      return "#000000";
  }
};
